/** Search params used in the refill page. */
export const searchParametersRefill = {
    AMOUNT_MAX: 'amount_max',
    AMOUNT_MIN: 'amount_min',
    CARD: 'card',
    DATE_START: 'date_start',
    DATE_END: 'date_end',
    MANAGERS: 'managers',
    NAME: 'name',
    REFILL: 'refill',
}

/** Search params used in the refill API. */
export const searchParametersRefillApi = {
    AMOUNT_MAX: 'total__lte',
    AMOUNT_MIN: 'total__gte',
    CARD: 'pan__icontains',
    DATE_END: 'date_time__lte',
    DATE_START: 'date_time__gte',
    MANAGERS: 'machine_user__client',
    NAME: 'search',
    REFILL: 'id__icontains',
}
